import { useSearch } from "@tanstack/react-location";
import { useQuery } from "@tanstack/react-query";
import { currencyQuery } from "../utils/query";
import { getWhiteLabel } from "../utils/white-label";
import type { LocationGenerics } from "../pages/routing";

type UseCurrencyOutput = {
  currency: string;
};

export const useCurrency = (): UseCurrencyOutput => {
  const { currency } = useSearch<LocationGenerics>();
  const userCurrencyQuery = useQuery(
    ["userCurrency"],
    () => currencyQuery.getCurrencyCodeByIp() ?? "", // react query doesn't like when a query returns a undefined
    {
      enabled: !currency,
    },
  );
  const { currency: defaultCurrency } = getWhiteLabel();

  return {
    currency: currency || userCurrencyQuery.data || defaultCurrency,
  };
};
